export const envVarKeys = {
  all: ['all-env-vars'],
  envVar: ['env-var'],
  projectEnvVars: (slug: string) => [...envVarKeys.all, slug],
  envVarById: (slug: string, id: number) => [...envVarKeys.envVar, slug, id],
};
